import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '../components';
import { WhatsAppSetupForm } from '../components/WhatsAppSetupForm/WhatsAppSetupForm';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import {
  AUTH_FORM_CARD_CLASS,
  AUTH_SUBTITLE_CLASS,
  AUTH_TITLE_CLASS,
} from '../lib/authStyles';

function resolveCompanyId() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      if (userObj?.company_id) return userObj.company_id;
    }
  } catch {
    // fall through
  }
  return localStorage.getItem('company_id');
}

export function WhatsAppSetupPage() {
  const navigate = useNavigate();

  const companyId = resolveCompanyId();

  const handleBack = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const handleSuccess = () => {
    navigate('/whatsapp-activation');
  };

  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <div className="animate-fadeIn">
        <h1 className={AUTH_TITLE_CLASS}>WhatsApp Connection</h1>
        <h2 className={AUTH_SUBTITLE_CLASS}>
          Connect WhatsApp with Meta to start engaging with your customers.
        </h2>

        <div className={`${AUTH_FORM_CARD_CLASS} text-left`}>
          <WhatsAppSetupForm companyId={companyId} onSuccess={handleSuccess} />
          <div className="text-center mt-6">
            <button
              type="button"
              onClick={handleBack}
              className="text-body-lg font-normal font-sf-pro-display text-text-primary hover:text-primary transition-colors cursor-pointer inline-flex items-center gap-1.5"
            >
              <svg
                className="w-4 h-4 inline"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5L8.25 12l7.5-7.5"
                />
              </svg>
              <span>Back to Login</span>
            </button>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
